import { withStyles } from '@material-ui/core/styles';
import { push } from 'connected-react-router';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setTitle_ac } from '../actions/me.ac.js';
import { WidgetContainer } from './Widgets/index.js';

class OpenOrdersWidgetContainer extends React.Component {
  render() {
    return (
      <WidgetContainer
        widgetName="open_orders"
        widgetProps={{}}
        autoFullHeight={true}
        style={{
          //make it be the whol width and height of the parent
          width: '98%',
          marginTop: '10px',
          marginBottom: '10px',
          height: 'calc(100vh - 2px)',
        }}
      />
    );
  }
}

const mapStateToProps = (stateFromStore) => ({
  me: stateFromStore.me,
  lookups: stateFromStore.lookups,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setTitle_ac,
      changePage: (path) => push(path),
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles({})(OpenOrdersWidgetContainer))
);
